import { h } from 'preact'
/** @jsx h */
import { WIZARD_ANSWER } from '../state/actions/Wizard.actions'
import { useAppState } from '../state/Quiz.context'
import { QUIZ_ANSWER } from '../state/actions/Quiz.actions'
import classNames from 'classnames'
export const WizardAnswer = () => {
  const [{ wizard, quiz }, dispatch] = useAppState()
  const question = quiz[wizard.current]
  const answers = Object.keys(question.answers).map(a => ({
    ...question.answers[a],
    key: a
  }))

  const onClick = answer => () => {
    dispatch({
      type: QUIZ_ANSWER,
      payload: {
        question: wizard.current,
        answer: answer.key
      }
    })
    if (answer.next) {
      dispatch({ type: WIZARD_ANSWER, payload: answer.next })
    } else {
      dispatch({ type: WIZARD_ANSWER, payload: answer.result })
    }
  }
  const longAnswers =
    answers.filter(a => a.title.split(' ').length > 1).length > 0
  return (
    <div className="c-quiz__question">
      <div
        className={classNames('c-quiz__answers', {
          'c-quiz__answers--column': longAnswers
        })}
      >
        {answers.map(a => {
          return (
            <div
              key={`${wizard.current}-${a.key}`}
              className={classNames('c-quiz__answer', {
                'c-quiz__answer--selected': a.selected,
                'c-quiz__answer--flex': longAnswers
              })}
              onClick={onClick(a)}
            >
              <div className="u-image c-quiz__answer-image">
                <img
                  className="u-image__background"
                  src={a.image}
                  alt={a.title}
                />
              </div>
              <button class="c-quiz__answer-btn">
                <svg
                  className={classNames('c-icon', 'c-quiz__answer-check', {
                    'c-quiz__answer-check--selected': a.selected
                  })}
                >
                  <use href="#quiz-check" xlinkHref="#quiz-check" />
                </svg>
                <span className={classNames('c-quiz__answer-title')}>
                  {a.title}
                  <svg className="c-icon c-quiz__answer-next">
                    <use
                      href="#quiz-arrow-right"
                      xlinkHref="#quiz-arrow-right"
                    />
                  </svg>
                </span>
                <div />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/js/quiz/components/WizardAnswer.jsx